<template>
  <div class="qianqing-task-page">
    <SyncConfigForm ref="form" v-model="form" />
    <div class="save-actions">
      <a-button type="primary" :loading="saving" @click="handleSave">保存</a-button>
    </div>
  </div>
</template>

<script>
import SyncConfigForm from './SyncConfigForm.vue'
import {
  createSyncConfigForm,
  buildSpecifiedList,
  buildSaveParams
} from '../utils/syncConfigHelper'

export default {
  name: 'TaskListComponent',
  components: {
    SyncConfigForm
  },
  data () {
    return {
      saving: false,
      form: createSyncConfigForm({
        syncType: 1, // 全量同步
        productInfoStrategy: 1, // 每次更新
        priceStockStrategy: 2 // 每次仅更新库存，不更新价格
      })
    }
  },
  methods: {
    async handleSave () {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      const userInfo = this.$store.getters.userInfo || {}
      if (this.form.syncType === 2 && !buildSpecifiedList(this.form, userInfo).length) {
        this.$message.warning('请填写有效的千擎线路编码')
        return
      }
      this.saving = true
      this.getHttpServices()
        .getSourceService()
        .post('/qianqing/syncConfig/save', buildSaveParams(this.form, userInfo, { enabled: 1 }))
        .then(() => {
          this.$message.success('保存成功')
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '保存失败，请重试')
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style scoped lang="less">
.qianqing-task-page {
  padding: 8px 16px 24px;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.save-actions {
  margin-left: 12.5%;
  padding-bottom: 16px;
}
</style>
